import React, {useState, useEffect} from 'react';
import FolderComponent from './FolderComponent.js';

export default function XanaduFolders(props) {
    let root = props.root;
    const [subFolders, setSubFolders] = useState(root.subFolders);
    useEffect(() => {
        if (!props.root.isLoaded) {
            props.root.load()
                .then(() => 
                      setSubFolders([... props.root.subFolders]));
        }
    }, [props.root]);

    const onChooseItem = (item) => {
        console.log('choose item ', item);
        let {fromData} = item;
        props.sequencerEngine.loadSampleFromSequence(item.getId(), fromData);
    };

    const onChooseFolder = (folder) => {
        console.log('choose folder ', folder);
    };

    const onTestItem = (item) => {
    };

    let subFoldersToShow = [... subFolders];
    if (subFoldersToShow.length > 500) {
        subFoldersToShow = subFolders.slice(0, 500);
    }

    return (
        <div className="folders-container xanadu-folders">
          {subFoldersToShow.map(
                  folder => 
                      <FolderComponent
                            key={folder.name}
                            onFoldersUpdated={() => []}
                            onChooseItem={onChooseItem}
                            onChooseFolder={onChooseFolder}
                            onTestItem={onTestItem}
                            showItems={true}
                            folder={folder}
                        />)}
           
        </div>
    );
}
